import api from "../configurations/axios";
import BonusWinnerDetailsResponse from '../responses/BonusWinnerDetailsResponse'
import { GetBonusWinnerRequest } from "../requests/GetBonusWinnerRequest"

class BonusWinnersService {
    async selectBonusWinner(
        competitionId: number,
        payload: GetBonusWinnerRequest
    ): Promise<BonusWinnerDetailsResponse> {
        try {
            const response = await api.post<BonusWinnerDetailsResponse>(
                `api/bonus-winners/${competitionId}`,
                payload
            )

            return response.data
        } catch (error) {
            throw error
        }
    }
}

export default new BonusWinnersService();
